import parse from 'html-react-parser';
import _ from 'lodash';
import { NextSeo } from 'next-seo';
import Head from 'next/head';
import PageError from 'pages/404';
import Layout from 'src/components/layouts';
import { APP_IMG, SHOW_COMMEMORATE } from 'src/constants';
import { decryptionClient } from 'src/services/member-auth/utils/decryption-payload';
import client from 'src/utils/client';
import { useDesktop } from 'src/utils/device';
import { GET } from 'src/utils/services';
import useUser from 'src/utils/useUser';

const PageSeminar = ({ data, dataAdsHeader }) => {
  const _data = useUser();
  const sessionSevId = _data?.user ? decryptionClient(_data?.user) : null;
  if (_.isEmpty(data)) {
    return <PageError dataAdsHeader={dataAdsHeader} sessionSevId={sessionSevId} />;
  }
  const urlPath = 'https://nregister.nationgroup.com/TMMCO2/register.php';
  return (
    <>
      <NextSeo
        noindex={true}
        nofollow={true}
        title={`${data.title} - กรุงเทพธุรกิจ`}
        robotsProps={{
          maxImagePreview: 'large',
          maxSnippet: -1,
          maxVideoPreview: -1
        }}
      />
      <Head>
        {/* ----------------------------- ScriptBrowser ------------------------------------ */}
        {!useDesktop() && !_.isEmpty(dataAdsHeader) ? parse(`${dataAdsHeader?.header_mobile}`) : ''}
        {useDesktop() && !_.isEmpty(dataAdsHeader) ? parse(`${dataAdsHeader?.header_desktop}`) : ''}
        {/* ----------------------------- ADS : PPN ------------------------------- */}
        <script async type='text/javascript' src='https://securepubads.g.doubleclick.net/tag/js/gpt.js' />
        <script
          type='text/javascript'
          dangerouslySetInnerHTML={{
            __html: 'var googletag = googletag || {}; window.googletag.cmd = googletag.cmd || [];'
          }}
        />
        {/* --------------------------------- Truehit -------------------------------- */}
        <script
          type='text/javascript'
          dangerouslySetInnerHTML={{
            __html: `
                __th_page="seminar";
              `
          }}
        />
        {/* <img
              width='99999'
              height='99999'
              alt='background-default'
              title='background-default'
              className='background-default'
              style={{
                pointerEvents: 'none',
                position: 'absolute',
                top: 0,
                left: 0,
                width: '99vw',
                height: '99vh',
                maxWidth: '99vw',
                maxHeight: '99vh'
              }}
              src='data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSI5OTk5OXB4IiBoZWlnaHQ9Ijk5OTk5cHgiIHZpZXdCb3g9IjAgMCA5OTk5OSA5OTk5OSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48ZyBzdHJva2U9Im5vbmUiIGZpbGw9Im5vbmUiIGZpbGwtb3BhY2l0eT0iMCI+PHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9Ijk5OTk5IiBoZWlnaHQ9Ijk5OTk5Ij48L3JlY3Q+IDwvZz4gPC9zdmc+'
            ></img> */}
      </Head>
      <Layout sessionSevId={sessionSevId}>
        <div className='seminar-wrapper' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : 'unset' }}>
          <a href={'url' in data ? data.url : urlPath} target='_blank' rel={'noopener noreferrer nofollow'}>
            <img src={`${APP_IMG}/${data.imagePath}`} alt={data.title} className='show-desktop' />
          </a>
          <a href={'url' in data ? data.url : urlPath} target='_blank' rel={'noopener noreferrer nofollow'}>
            <img src={`${APP_IMG}/${data.imagePathMobile}`} alt={data.title} className='show-mobile' />
          </a>
        </div>
      </Layout>
    </>
  );
};

export async function getServerSideProps({ req, res, query }) {
  const initProps = {
    statusCode: 200,
    errMessage: null,
    data: [],
    dataAdsHeader: null
  };
  const scriptBrowser = await GET('/api/headerAds');
  if (!_.isEmpty(scriptBrowser)) {
    initProps.dataAdsHeader = scriptBrowser || '';
  }
  try {
    const data = await client.get(`/api/seminar/${query.id}`);
    if ('msg' in data) {
      initProps.data = [];
    } else {
      initProps.data = data;
    }
  } catch (err) {
    console.log('==========> Seminar ERROR', err.message);
    initProps.errMessage = err.message;
    initProps.statusCode = err?.response?.status || 500;
  }

  return {
    props: initProps
  };
}

export default PageSeminar;
